<template>
  <div>
    <div class="fa">
      <img src="../assets/pic/success.png" alt="" />

      <span slot="reference">成功</span>

      <!-- <el-button @click="closeDown">关闭</el-button> -->
      <p>{{ message }}</p>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.message = window.location.href;
  },
  data() {
    return {
      message: ""
    };
  },
  mounted() {
    setTimeout(() => {
      /* esllint-disabled */
      WeixinJSBridge.call("closeWindow");
      android.finishActivity();
      //这个可以关闭安卓系统的手机
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          WeixinJSBridge.call("closeWindow");
        },
        false
      );
    }, 100);
  },
  methods: {
    closeDown() {}
  }
};
</script>
<style scoped>
.fa {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 202px;
  height: 250px;
}
img {
  width: 200px;
  height: 200px;
}
span {
  width: 200px;
  height: 50px;
  display: inline-block;
  overflow: hidden;
  text-align: center;
  font-size: 24px;
}
.el-button {
  width: 200px;
}
</style>
